// Generated types for RequirementExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityExtractionTaskReadAPI, EntityExtractionTaskWriteAPI } from './entityextractiontask';
import { EntityExtractionTaskReadAPISchemaObject, EntityExtractionTaskWriteAPISchemaObject } from './entityextractiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RequirementExtractionTaskReadAPI extends EntityExtractionTaskReadAPI {
}

export interface RequirementExtractionTaskWriteAPI extends EntityExtractionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RequirementExtractionTaskReadAPISchema: z.ZodType<RequirementExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject.extend({}).passthrough();

export const RequirementExtractionTaskWriteAPISchema: z.ZodType<RequirementExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject.extend({}).passthrough();
